module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step3-2-2587c9d6540882dca8f3f6834593243e.gif";